
// import InlineSvg from "vue-inline-svg";
export default {
  name: "CustomerCard",
  // components: {
  //   InlineSvg
  // },
  props: ["imgSrc", "name", "city", "rating", "body"]
};
